import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { ApiHistoryService } from '../layouts/data-access/api-history.service';
import { ApiHistory } from '../layouts/models/api-history';
import { sanitizeBody } from '../shared/utils/general/validaciones';
import { tap } from 'rxjs';

export const API_DESC = new HttpContextToken(() => 'DESCONOCIDO');

export const peticionHistoryInterceptor: HttpInterceptorFn = (req, next) => {

  if(req.url.includes('auth'))
  return next(req);
  
  const descri = req.context.get(API_DESC);
  const service = inject(ApiHistoryService)
  const start = performance.now()
  const hasBody = ['POST', 'PUT', 'PATCH'].includes(req.method)
  const id = `${Date.now()}-${Math.random().toString(36).substring(2, 8)}`
  const keys = req.params.keys();
  const queryParams = keys?.length ? Object.fromEntries(
      keys.map(key => [key, req.params.get(key)])
    ) : null;
    
  return next(req).pipe(
    
    tap({
      
      next: (event) => {
        
        if(event instanceof HttpResponse){
          const apiResult: ApiHistory = {
            descri,
            url: event.url,
            method: req.method,
            status: event.status,
            duration: Math.round(performance.now() - start),
            ok: true,
            body: hasBody ? sanitizeBody(req.body) : null,
            responseBody: sanitizeBody(event.body),
            queryParams,
            id
          }
          service.add(apiResult);
        }
          

      },
      error: (err: HttpErrorResponse) => {
        const apiResult: ApiHistory = {
          descri,
          url: err.url,
          method: req.method,
          status: err.status,
          duration: Math.round(performance.now() - start),
          ok: false,
          error: err.error,
          body: hasBody ? sanitizeBody(req.body) : null,
          queryParams,
          id
        }
        service.add(apiResult);
      }
    })
  );
};
